/** 页面跳转类型 */
export enum PageOpenType {
  /** 在内部框架中打开 */
  routerView = '1',
  /** 新页面打开 */
  newPage = '2',
  /** 在当前页面打开 */
  currentPage = '3',
}
